import React, { useState,useEffect } from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import InputMask from "react-input-mask";
import { identify,verify } from '../../service/api';
import { useTranslation } from 'react-i18next';


const Landing =()=>{
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar"
    const [msisdn,setMsisdn]=useState('')
    const [phoneVisible,setPhoneVisible]=useState(true);
    const [otp,setOTP]=useState(null);
    const [otpVisible,setOTPVisible]=useState(false);
    const [thankYou,setThankYou]=useState(false);
    const [loading,setLoading]=useState(false);
    const [verification_req_pub_id, setVerificationReqPubId] = useState('');
    const [msg,setMsg] = useState('');
    const [game_url, setGameUrl] = useState('');

    const isPhoneNumberComplete = (phoneNumber) => {
      return phoneNumber && phoneNumber.length >= 11; 
    };

    const isOtpComplete = (otp) =>{
        return otp.length>=4;
    };


    const handleSubmit = () =>{
      setLoading(true); 
      setMsg('');
      const formData = new FormData();
      formData.append('msisdn', msisdn);
      formData.append('country_code', "tun");
      formData.append('operator_code', "TELECOM_TUNISIA");
      formData.append('service_slug', "FFOOTBALL");
      formData.append('language', i18n.language);
      if(isPhoneNumberComplete(msisdn)){
        identify(formData)
            .then(response => {
                setVerificationReqPubId(response.data.payload.verification_req_pub_id);
                if (response.data.payload.verification_type == "LOGIN" ){
                    if(response.data.payload.redirect_url !== null){
                       window.location.href = response.data.payload.redirect_url
                    }
                setMsg(t('already_subscriber'));
                }
                setPhoneVisible(false);
                setOTPVisible(true);
                setThankYou(false);
                setLoading(false); 

            })
            .catch(error => {
            console.error("Error fetching data:", error);
            setMsg(t('incorrect'));
            setLoading(false);
            });
        }else{
            setMsg(t('incorrect'));
            setLoading(false);
        }

    }

    const handleOTP = () =>{
        setLoading(true); 
        setMsg('');
        const formData = new FormData();
        formData.append('pin_code', otp);
        formData.append('country_code', "tun");
        formData.append('verification_req_pub_id', verification_req_pub_id);
        formData.append('service_slug', "FFOOTBALL");

        if(isOtpComplete(otp)){
            verify(formData)
            .then(response => {
                setGameUrl(response.data.payload.app_game_url);
                setPhoneVisible(false);
                setOTPVisible(false);
                setThankYou(true);
                setOTP('');
                setMsisdn('');
                setMsg('');
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
        }else{
            setMsg(t('incorrect'));
            setLoading(false);
        }

    }

    return(
        <div className={`landing-bg d-flex flex-column justify-content-center ${isArabic ? "landing-bg-arabic":""}`}>
            <div className='container landing-content-mobile' style={{color:"white"}}>
                    <div className='pb-3'>
                        <img src="/assets/images/tunisia_logo.png" className='tunisia-logo'/>
                    </div>
                   <div className='py-5 landing-text'>
                     <h5 dangerouslySetInnerHTML={{ __html:  t('landing.title')}}></h5>
                   </div>

                   {phoneVisible && (
                        <div className="row d-flex align-items-center pb-2" style={{width:"100%"}}>  
                            {loading ? (
                                <div className='col-lg-6 col-md-12 text-center'>
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                
                            ):(
                                <>
                                   <div className='col-12 col-lg-auto mt-2 d-flex flex-column landing-content-mobile' style={{direction:"ltr"}}>
                                    <PhoneInput value={msisdn} onChange={(msisdn) => setMsisdn(msisdn)} defaultCountry="tn"/>
                                    {msg && <p className={`text-left poppins-regular mb-0`} style={{ color: "red" }}>{msg}</p>} 
                                   </div>
                                    <div className='col-12 col-lg-auto mt-2 landing-content-mobile'>
                                        <div className="d-flex align-items-center">
                                            <button id="identify" className="btn sparkling-button button poppins-bold" onClick={()=>handleSubmit()}>
                                                <span>{t('landing.continue')}</span>
                                                {/* <span className="sparkle"></span> */}
                                            </button>
                                        </div> 
                                    </div> 
                                </>
                            )}            
                                                         
                        </div>
                    )}   
                    {otpVisible && (
                        <div className="d-flex align-items-center pb-2 landing-content-mobile">  
                            {loading ? (
                                <div className='col-lg-6 col-md-12 text-center'>
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                
                            ):(
                            <>  
                                <div className='col-12 col-lg-auto mt-2 d-flex flex-column landing-content-mobile' style={{direction:"ltr"}}>
                                    <div>
                                        <input
                                        id="pinCode"
                                        style={{
                                            textAlign: "center",
                                            height: "40px",
                                            borderRadius: "50px",
                                            border: "0px",
                                            width: "100%",
                                            letterSpacing: 10,
                                            marginTop: "0.25rem",
                                            padding: "0px 40px"
                                        }}
                                        type="tel" // Use type="tel" for numeric input on mobile devices
                                        className="code-input"
                                        placeholder="_ _ _ _"
                                        maxLength={4}
                                        value={otp}
                                        onChange={(e) => {
                                            // Only allow digits
                                            setOTP(e.target.value.replace(/\D/g, ''));
                                        }}
                                        autoFocus
                                    />
                                    </div>
                                    {msg && <p className={`text-left poppins-regular mb-0`} style={{ color: "red" }}>{msg}</p>} 
                                </div>
                                <div className='col-12 col-lg-auto mt-2 landing-content-mobile'>
                                    <div className="d-flex align-items-center mx-2">
                                        <button  id="submit" className="btn sparkling-button button poppins-bold"  onClick={()=>handleOTP()}>
                                            <span>{t('landing.verify')}</span>
                                            {/* <span className="sparkle"></span> */}
                                        </button>
                                    </div> 
                                </div>                  
                            </>     
                            )}                       
                        </div>
                    )} 
                    {thankYou && (
                        <div className="d-flex flex-column mx-2">
                            <button className="btn sparkling-button button poppins-bold"  onClick={() => window.location.href = game_url}>
                                <span>{t('play')}</span>
                                <span className="sparkle"></span>
                            </button>
                        </div>

                    )}  
                    <div className='col-6 text-center pt-3'>
                        <div className='landing-content-mobile' style={{color:"#9cc6eb"}}>
                            <h6 dangerouslySetInnerHTML={{ __html:  t('landing.pricepoint')}}></h6>
                        </div> 
                    </div>          

            </div>
        </div>
    )

}

export default Landing;